/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Value set on a tunnel variable value (pricing variable, ceiling or deductible).
 * @export
 * @interface RetarificationVariableValeurDto
 */
export interface RetarificationVariableValeurDto {
    /**
     * 
     * @type {string}
     * @memberof RetarificationVariableValeurDto
     */
    variableValueId: string;
    /**
     * 
     * @type {number}
     * @memberof RetarificationVariableValeurDto
     */
    valeur: number;
}

/**
 * Check if a given object implements the RetarificationVariableValeurDto interface.
 */
export function instanceOfRetarificationVariableValeurDto(value: object): value is RetarificationVariableValeurDto {
    if (!('variableValueId' in value) || value['variableValueId'] === undefined) return false;
    if (!('valeur' in value) || value['valeur'] === undefined) return false;
    return true;
}

export function RetarificationVariableValeurDtoFromJSON(json: any): RetarificationVariableValeurDto {
    return RetarificationVariableValeurDtoFromJSONTyped(json, false);
}

export function RetarificationVariableValeurDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetarificationVariableValeurDto {
    if (json == null) {
        return json;
    }
    return {
        
        'variableValueId': json['variableValueId'],
        'valeur': json['valeur'],
    };
}

export function RetarificationVariableValeurDtoToJSON(json: any): RetarificationVariableValeurDto {
    return RetarificationVariableValeurDtoToJSONTyped(json, false);
}

export function RetarificationVariableValeurDtoToJSONTyped(value?: RetarificationVariableValeurDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableValueId': value['variableValueId'],
        'valeur': value['valeur'],
    };
}

